import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';
import {browserHistory} from 'react-router';

import {completeEmailVerification} from '../../../ducks/auth';

import Loader from '../../../components/loader/Loader';
import withChannelFormatters from '../../channelUtils/withChannelFormatters';

@withChannelFormatters
@connect()
export default class EmailVerificationPage extends React.PureComponent {
  componentDidMount() {
    const {dispatch, params, channelFormatters} = this.props;

    dispatch(completeEmailVerification(params.userId, params.token))
      .then(
        () => browserHistory.push(channelFormatters.link('/profile')),
        () => browserHistory.push(channelFormatters.link('/profile'))
      );
  }

  render() {
    return <Loader page/>;
  }
}



// WEBPACK FOOTER //
// ./containers/auth/pages/EmailVerificationPage.js